import React from 'react';

// Tiny inline SVG flags — render identically on every OS (Windows emoji flags
// fall back to "EU/US" letters, so we draw them instead).
const wrap = { display: 'inline-block', width: 21, height: 14, borderRadius: 2, overflow: 'hidden', verticalAlign: '-2px', boxShadow: '0 0 0 1px rgba(255,255,255,.15)' };

const EU = () => (
  <svg viewBox="0 0 30 20" style={wrap} aria-hidden>
    <rect width="30" height="20" fill="#003399" />
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i / 12) * 2 * Math.PI - Math.PI / 2;
      return <circle key={i} cx={15 + 6 * Math.cos(a)} cy={10 + 6 * Math.sin(a)} r="1.1" fill="#FFCC00" />;
    })}
  </svg>
);

const US = () => (
  <svg viewBox="0 0 30 20" style={wrap} aria-hidden>
    <rect width="30" height="20" fill="#fff" />
    {[0, 1, 2, 3, 4, 5, 6].map((i) => (
      <rect key={i} y={i * 3.077} width="30" height="1.538" fill="#B22234" />
    ))}
    <rect width="13" height="10.77" fill="#3C3B6E" />
    {[2.5, 6.5, 10.5].map((x) => [2, 5, 8].map((y) => (
      <circle key={`${x}-${y}`} cx={x} cy={y} r="0.7" fill="#fff" />
    )))}
  </svg>
);

const GB = () => (
  <svg viewBox="0 0 60 40" style={wrap} aria-hidden>
    <rect width="60" height="40" fill="#012169" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="4" />
    <rect x="24" width="12" height="40" fill="#fff" />
    <rect y="14" width="60" height="12" fill="#fff" />
    <rect x="26" width="8" height="40" fill="#C8102E" />
    <rect y="16" width="60" height="8" fill="#C8102E" />
  </svg>
);

const UA = () => (
  <svg viewBox="0 0 30 20" style={wrap} aria-hidden>
    <rect width="30" height="10" fill="#0057B7" />
    <rect y="10" width="30" height="10" fill="#FFDD00" />
  </svg>
);

const MAP = { EU, US, GB, UA };

const Flag = ({ code }) => {
  const C = MAP[code];
  return C ? <C /> : null;
};

export default Flag;
